// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const machop: PokeData = {
  "id": 66,
  "name": "machop",
  "height": 8,
  "weight": 195,
  "base_experience": 61,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "karate-chop",
    "tackle",
    "double-edge",
    "leer",
    "submission",
    "low-kick",
    "seismic-toss",
    "strength",
    "focus-energy",
    "bide",
    "mach-punch",
    "scary-face",
    "foresight",
    "dynamic-punch",
    "vital-throw",
    "cross-chop",
    "rock-smash",
    "superpower",
    "revenge",
    "brick-break",
    "knock-off",
    "bulk-up",
    "wake-up-slap",
    "close-combat",
    "bullet-punch",
    "double-hit",
    "low-sweep",
    "dual-chop"
  ],
  "moves": [
    "karate-chop",
    "tackle",
    "leer",
    "seismic-toss",
    "scary-face",
    "rock-smash",
    "superpower",
    "bulk-up",
    "close-combat",
    "coaching",
    "jump-kick",
    "meteor-assault",
    "rolling-kick"
  ],
  "evolution_chain": {
    "id": 28,
    "item": null,
    "species": [
      {
        "name": "machop",
        "order": 72,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "machoke",
        "order": 73,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 66,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "machamp",
        "order": 74,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 67,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 35,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
